import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { updateFollowUp } from "reduxStore/action/followUpActions";
import { getFollowUpDetail } from "reduxStore/action/followUpActions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { errorToast } from "utils/httpClient";
import { seo } from "utils/utils";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { handleDetailResponse } from "../../utils/utils";

const EditFollowup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [viewData, setViewData] = useState({});
  const [form, setForm] = useState({});
  const followupDetailSelector = useSelector((state) => state.followUp);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const params = useParams();
  const { _id = "" } = params || {};

  useEffect(() => {
    if (followupDetailSelector.detail === true) {
      const { response } = followupDetailSelector;
      if (response?.status === 200) {
        setViewData(handleDetailResponse(response?.data));
        setForm({
          ...form,
          remark: handleDetailResponse(response?.data).remark,
          followup_time:
            handleDetailResponse(response?.data)?.followup_time ===
              "Invalid date"
              ? moment().format("h:mm a")
              : handleDetailResponse(response?.data)?.followup_time,
          next_followup_date: moment(
            handleDetailResponse(response?.data).next_followup_date
          ).format("yyyy-MM-DD"),
        });
      }
    } else {
      if (followupDetailSelector.create === true) {
        if (followupDetailSelector?.response?.status === 200) {
          setForm({});
          navigatpage("/followup");
        } else {
          errorToast(followupDetailSelector?.response?.message);
        }
      }
    }
  }, [followupDetailSelector]);

  useEffect(() => {
    dispatch(getFollowUpDetail({ followup_id: _id }));
  }, []);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (followup_time) => {
    if (followup_time) {
      const nextFormState = {
        ...form,
        followup_time: moment("2000-01-01 " + followup_time).format("hh:mm A"),
      };
      setForm(nextFormState);
    }
  };
  const handleEdit = () => {
    if (!handleValid()) {
      const post = {
        followup_id: viewData._id,
        lead_id: viewData.lead_id,
        followup_for: viewData.followup_for,
        followup_status: viewData.followup_status,
        lead_status: viewData.lead_status,
        lead_source: viewData.lead_source,
        remark: form.remark,
        followup_time: form.followup_time,
        next_followup_date: moment(form.next_followup_date).format(
          "yyyy-MM-DD"
        ),
      };
      dispatch(updateFollowUp(post));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;

    if (!form.next_followup_date) {
      formError = true;
      err["next_followup_date"] = strings.followup_dateErr;
    }
    if (!form.remark) {
      formError = true;
      err["remark"] = strings.remarkErr;
    }

    if (!form.followup_time) {
      formError = true;
      err["followup_time"] = strings.followup_timeErr;
    }

    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Edit Followup",
      metaDescription: "Edit followup",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.editFollowup}
        url={"/followup"}
        parentListing={strings.followupList}
        titleactive={strings.EditFollowup}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.editFollowup}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-4 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.date}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control datetimepicker-input digits"
                          type="date"
                          name="next_followup_date"
                          value={form.next_followup_date}
                          onChange={handleInputField}
                           min={moment().add(1, "day").format("YYYY-MM-DD")}
                        />
                        {formVaild.next_followup_date && (
                          <span style={{ color: "red" }}>
                            {formVaild.next_followup_date}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3" id="add_time">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.time}
                          <span className="required-field"></span>
                        </label>
                        <TimePicker
                          onChange={handleInputTime}
                          value={form.followup_time}
                          type="time"
                          clockIcon={null}
                          clearIcon={null}
                          disableClock={true}
                          format={"hh:mm a"}
                          className="form-control"
                          name="followup_time"
                        />

                        {formVaild.followup_time && (
                          <span style={{ color: "red" }}>
                            {formVaild.followup_time}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="remark">{strings.description}</label>
                        <span className="required-field"></span>
                        <textarea
                          className="form-control"
                          type="text"
                          value={form.remark}
                          onChange={handleInputField}
                          name="remark"
                          id="remark"
                          cols="74"
                          rows="5"
                        ></textarea>
                        {formVaild.remark && (
                          <span style={{ color: "red" }}>
                            {formVaild.remark}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={() => handleEdit()}
                        >
                          {strings.update}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditFollowup;
